<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div>
                    <div class="content">
                        <div class="col-sm-7">
                            <p>
                                {{$t("fill_in_form")}}
                                <br>
                                <br>
                                <sup>{{$t("marked_are_mandatory")}}</sup>
                            </p>
                            <form class="form-horizontal" @submit.prevent="sendMail()">
                                <div class="form-group">
                                    <label class="control-label col-sm-3" for="name">{{$t("name")}}: *</label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control" id="name" v-model="mail.name"
                                               :placeholder="$t('name_mandatory')" required />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label col-sm-3" for="companyName">{{$t("company_name")}}:</label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control" id="companyName" v-model="mail.companyName"
                                               :placeholder="$t('company_name')">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label col-sm-3">{{$t("email")}}: *</label>
                                    <div class="col-sm-9">
                                        <input type="email" class="form-control" required v-model="mail.email"
                                               :placeholder="$t('email_mandatory')">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label col-sm-3" for="phonenumber">{{$t("phone_number")}}:</label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control" id="phonenumber" v-model="mail.phoneNumber"
                                               :placeholder="$t('phone_number')">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label col-sm-3" for="remark">{{$t("remarks_title")}}</label>
                                    <div class="col-sm-9">
                                        <textarea type="text" class="form-control" style="resize: none" v-model="mail.remark" rows="8"
                                                  id="remark"
                                                  :placeholder="$t('remarks_placeholder')"></textarea>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-sm-offset-3 col-sm-4">
                                        <button type="submit" class="btn btn-danger">{{$t("send")}}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="col-sm-offset-1 col-sm-4">
                            <h3>Brabant Tools BV</h3>
                            <p>Draaiboom 51</p>
                            <p>5094 CB Lage Mierde</p>
                            <p>Telefoon nr.: +31 (0)497-701301</p>
                            <p>
                                E-mailadres:
                                <a href="mailto:info@brabanttools.nl" title="info@brabanttools.nl">info@brabanttools.nl</a>
                            </p>
                            <p>KvK: 67240933</p>
                            <p>BTW: NL856891629B01</p>
                            <p>IBAN: NL68 ABNA 0624 5956 25</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bt-footer />
    </div>
</template>

<script>
    import BtFooter from './BTFooter.vue'
    import { mapGetters } from 'vuex'
    import * as types from '../store/mutation-types'

    export default {
        name: 'Contact',
        data() {
            return {
                mail: { name: '', companyName: '', email: '', phoneNumber: '', remark: '' }
            }
        },
        created() {
            document.title = 'Brabant-Tools | Contact'
        },
        methods: {
            sendMail() {
                this.$store.commit(types.SET_MAIL_TO_SEND, this.mail)
                this.$store.dispatch('sendContactMail').then(() => {
                    if (this.isMailSent) {
                        this.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Email is verzonden! U hoort zo spoedig mogelijk van ons.' })
                    }
                })
            }
        },
        components: {
            BtFooter
        },
        computed: {
            ...mapGetters({
                isMailSent: 'isMailSent'
            })
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
